import intl from 'react-intl-universal';
import { LANGUAGE_KEY_MAPPING } from './constants';

export const getBrowserLanguage = () => {
	const currentLanguage = navigator.language;
	const keys = currentLanguage ? currentLanguage.split('-') : null;
	let languageKey = 'en';
	if (keys?.length > 0) {
		languageKey = keys[0];
	}
	// console.log(languageKey);
	return LANGUAGE_KEY_MAPPING[languageKey] || 'en-US';
};

const _e = (key, dict, defaultValue) => {
	let translation = '';
	if (!key || typeof key !== 'string') {
		// Sentry && Sentry.captureMessage('intl key is null or not a string');
	} else {
		if (dict && dict.html) {
			translation = intl.getHTML(key, dict);
		} else {
			translation = intl.get(key, dict);
		}

		if (!translation) {
			translation = defaultValue;
		}
		if (!translation && key) {
			if (dict && !dict.ignoreMissingKey) {
				console.log(`Translation "${key}" not found.`);
			}
		}
		if (dict && dict.capitalize) {
			return translation && translation.capitalize();
		}
	}

	return translation;
};

export default _e;
